var _path, _path2, _rect, _rect2, _circle, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraPermissionNeededIconinline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.863 18.194a2.758 2.758 0 01-2.452 1.497H4.896a2.767 2.767 0 01-2.756-2.756V7.618c.016-1.513 1.243-2.755 2.756-2.755h.637l13.33 13.33zM19.166 7.618v7.964L8.447 4.863h7.964c1.529.016 2.755 1.242 2.755 2.755zM25.326 6.387c-.16.032-.319.095-.462.191l-3.839 2.214a.904.904 0 00-.461.796v5.336c0 .334.175.637.461.796l3.87 2.214c.78.462 1.784.207 2.246-.574 0-.016.016-.016.016-.032.143-.254.223-.541.223-.828V7.98a1.655 1.655 0 00-1.672-1.64c-.143 0-.271.015-.382.047z",
    fill: "#9AA3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.141 23.051c-.303 0-.59-.127-.812-.334L.834 2.936a1.173 1.173 0 010-1.64 1.126 1.126 0 011.625 0l19.494 19.78a1.173 1.173 0 010 1.64c-.223.224-.51.335-.812.335z",
    fill: "#9AA3B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 12,
    width: 11,
    height: 11,
    rx: 2,
    fill: "#E9BE25"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 12,
    width: 11,
    height: 11,
    rx: 2,
    stroke: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.912,
    cy: 20.235,
    r: 0.706,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.206,
    y: 13.882,
    width: 1.412,
    height: 5.176,
    rx: 0.706,
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraPermissionNeededIconinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera-permission-needed-icon.inline.494b619c553bcb9e088169185e2ba5c5.svg";